import { PropsWithChildren, useEffect, useState } from 'react'

import { cn } from '@/utils/tailwind'

interface PopupProps {
  show: boolean
  testId?: string
}

export const Popup = ({ show, children, testId }: PropsWithChildren<PopupProps>) => {
  const [visible, setVisible] = useState(false)
  const [hiding, setHiding] = useState(false)

  useEffect(() => {
    if (show) {
      setVisible(true)
      setHiding(false)
      return
    }

    if (!visible) return

    setHiding(true)
    const t = setTimeout(() => setVisible(false), 500)
    return () => clearTimeout(t)
  }, [show])

  if (!visible) return null

  return (
    <div
      className={cn(
        'shadow-popup absolute bottom-0 left-0 z-10 flex w-full flex-col items-center rounded-t-xl bg-white',
        hiding ? 'animate-slide-down' : 'animate-slide-up'
      )}
      data-testid={testId}
    >
      {children}
    </div>
  )
}
